import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface RejectionReasonAlertProps {
  reason: string
}

export const RejectionReasonAlert = ({ reason }: RejectionReasonAlertProps) => {
  return (
    <div className="container">
      <div className={s.alert}>
        <AppIcon
          id={AllIcons.INFO_TRIANGLE}
          width={24}
          height={24}
          className={s.icon}
        />

        <p className={clsx('medium-12', s.text)}>{reason}</p>
      </div>
    </div>
  )
}
